<template>
  <v-dialog width="800" v-if="image" v-model="cropperDialog" :key="index">
    <v-card>
      <v-card-title>
        <v-layout>
          <v-flex> Crop Image </v-flex>
          <v-flex text-right>
            <v-btn @click="cropperDialog = false" icon>
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <cropper
        class="cropper"
        style="height: 500px"
        ref="cropper"
        :src="image.staged"
        :stencil-props="{
          aspectRatio: 1 / 1,
        }"
        @change="change"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="cropperDialog = false"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          class="text-none subtitle-2"
          @click="saveCroppedImage"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default {
  components: {
    Cropper,
  },
  data() {
    return {
      canvas: "",
      cropperDialog: false,
      croppedImage: "",
      img: "",
      image: {},
      index: 0,
    };
  },
  methods: {
    change({ coordinates, canvas }) {
      // console.log(coordinates, canvas);
      this.canvas = canvas;
    },
    removeImage(index) {
      this.image.splice(index, 1);
    },
    saveCroppedImage() {
      let image = this.canvas.toDataURL();
      // console.log(image);
      this.croppedImage = image;
      let vm = this;
      let blob = this.canvas.toBlob(function (blob) {
        // vm.images.push({
        //   staged: image,
        //   file: blob,
        // });
        vm.cropperDialog = false;
        // vm.removeImage(0);
        vm.$emit("croppedImage", {
          staged: image,
          file: blob,
          index: vm.index,
        });
      }, "image/png");
    },
    toggleDialog(image, index) {
      this.image = image;
      this.index = index;
      console.log(image);
      this.cropperDialog = !this.cropperDialog;
    },
  },
};
</script>

<style>
.cropper {
  height: 500px;
  background: #ddd;
}
</style>